module.exports = __webpack_public_path__ + "img/Ellipsis.7eb73feb.svg";